import * as React from 'react';
import {useEffect, useState} from 'react';
import {
    DataGrid,
    getGridStringOperators,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarFilterButton,
    useGridApiRef
} from '@mui/x-data-grid';
import {connect} from "react-redux";
import {showToastForBackend, showToastForFrontend} from "../../actions/toastActions";
import axios from "axios";
import axiosConfig from "../../utils/axiosConfig";
import messageCodes from "../../utils/messageCodes";
import DataDetailModal from "./DataDetailModal";
import {CircularProgress} from "@mui/material";


const ItemDataDetail = (props) => {
    const apiRef = useGridApiRef();
    const [itemList, setItemList] = useState([]);
    const [columns, setColumns] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 25,
    });
    const [filterModel, setFilterModel] = React.useState({
        filterQuery: ""
    });
    const [rowCount, setRowCount] = useState();

    useEffect(() => {
        fetchColumnHeaders();
    }, []);

    useEffect(() => {
        fetchItemsList();
    }, [filterModel, paginationModel]);

    useEffect(() => {
        fetchRowsCount();
    }, [filterModel]);

    useEffect(() => {
        if (columns.length > 0) {
            const filterModel1 = localStorage.getItem('itemFilterSettings') ? JSON.parse(localStorage.getItem('itemFilterSettings')) : {items: []};
            apiRef.current.setFilterModel(filterModel1);
        }
    }, [apiRef, columns]);

    const fetchRowsCount = async () => {
        setIsLoading(true);
        let requestBody = {
            spelFilter: filterModel.filterQuery
        }
        await axios.post(props.properties.databaseUrl + "/items/count", requestBody, axiosConfig())
            .then((response) => {
                setRowCount(response.data);
            })
            .catch(error => {
                if (error.response) {
                    props.showToastForBackend(error.response.data);
                } else {
                    props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            }).finally(() => {
                setIsLoading(false);
            });
    }

    const fetchColumnHeaders = async () => {
        setIsLoading(true);
        await axios.get(props.properties.databaseUrl + "/properties/items", axiosConfig())
            .then((response) => {
                initVisibleColumns(response.data.sort());
            })
            .catch(error => {
                if (error.response) {
                    props.showToastForBackend(error.response.data);
                } else {
                    props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            }).finally(() => {
                setIsLoading(false);
            });
    };
    const filterOperators = getGridStringOperators().filter(
        (operator) => operator.value === 'contains'
    );
    const filterOperatorsForId = getGridStringOperators().filter(
        (operator) => operator.value === 'equals'
    );

    const initVisibleColumns = (columnHeaders) => {

        let initColumnHeaders = [];
        initColumnHeaders.push({
            field: 'entityId',
            headerName: 'ID',
            width: 200,
            sortable: false,
            filterOperators: filterOperatorsForId
        });
        initColumnHeaders.push({
            field: 'title',
            headerName: 'Title',
            width: 250,
            sortable: false,
            filterOperators: filterOperators
        });
        columnHeaders.filter(col => col !== "title").forEach((key) => {
                let column = {
                    field: key,
                    headerName: key,
                    sortable: false,
                    width: 200,
                    filterOperators: filterOperators
                }
                initColumnHeaders.push(column)
            }
        );
        let notVisible = [];
        initColumnHeaders.filter(c => !["entityId", "title"].includes(c.field)).forEach((key) => {
            notVisible[key.field] = false;
        });

        let infoButton =
            {
                field: 'action',
                headerName: '',
                width: 180,
                sortable: false,
                disableClickEventBubbling: true,
                renderCell: (params) =>
                    <DataDetailModal selectedRow={params.row}/>
            }

        initColumnHeaders.push(infoButton);
        setColumns(initColumnHeaders);
        let visible = localStorage.getItem('itemVisibleColumn') ?
            JSON.parse(localStorage.getItem('itemVisibleColumn')) : notVisible;
        setVisibleColumns(visible);
    }

    const fetchItemsList = async () => {
        setIsLoading(true);
        let start = paginationModel.page * paginationModel.pageSize;
        let requestBody = {
            limit: paginationModel.pageSize,
            offset: start,
            spelFilter: filterModel.filterQuery
        }

        await axios.post(props.properties.databaseUrl + "/items", requestBody, axiosConfig())
            .then((response) => {
                if (response.data === "Offset is equal or greater than the size of the result") {
                    setItemList([]);
                } else {
                    const array = [];
                    response.data.forEach(key => {
                        key.map.entityId = key.entityId;
                        array.push(key.map)
                    })
                    setItemList(array);
                }
            })
            .catch(error => {
                if (error.response) {
                    props.showToastForBackend(error.response.data);
                } else {
                    props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            }).finally(() => {
                setIsLoading(false);
            });
    };


    const findByEntityId = async (entityId) => {
        setIsLoading(true);
        await axios.get(props.properties.databaseUrl + "/items/" + entityId, axiosConfig())
            .then((response) => {
                if (Object.keys(response.data).length !==0) {
                    setItemList([response.data]);
                    setRowCount(response.data.size);
                } else {
                    setItemList([]);
                    setRowCount(0);
                }
            })
            .catch(error => {
                if (error.response) {
                    props.showToastForBackend(error.response.data);
                } else {
                    props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            }).finally(() => {
                setIsLoading(false);
            });
    };

    const onVisibilityModelChange = (newModel) => {
        setVisibleColumns(newModel);
        localStorage.setItem('itemVisibleColumn', JSON.stringify(newModel));
    };

    const onFilterModelChange = (filterModel) => {

        if (filterModel !== undefined && filterModel.items !== undefined && filterModel.items.length < 1) {
            setFilterModel({filterQuery: ""});
            const newFilterModel = ({...filterModel, filterQuery: ""});
            localStorage.setItem('itemFilterSettings', JSON.stringify(newFilterModel));
        } else {
            const {field, value} = filterModel.items[0];
            if (field === "entityId" && value !== undefined) {
                findByEntityId(value);
                localStorage.setItem('itemFilterSettings', JSON.stringify({items: filterModel.items}));
            }
            if (field === "entityId" && value === undefined) {
                setFilterModel({filterQuery: ""})
                localStorage.setItem('itemFilterSettings', JSON.stringify({items: [], filterQuery: ""}));
            }
            if (field !== "entityId") {
                let query = value !== undefined ? 'matches("' + field + '", "^.*' + value + '(.*$)")' : 'matches("' + field + '", "(.*$)")'
                setFilterModel({filterQuery: query});
                const newFilterModel = {...filterModel, filterQuery: query};
                localStorage.setItem('itemFilterSettings', JSON.stringify(newFilterModel));
            }
        }
    }

    const onPaginationModelChange = (newPageModel) => {
        setPaginationModel(newPageModel)
    };

    return (
        <div className="data-content">
            <div className="data-space">
                {isLoading && (
                    <CircularProgress/>)}</div>
            <div style={{height: '95%', width: '100%'}}>
                <DataGrid
                    apiRef={apiRef}
                    sx={{
                        '.MuiDataGrid-columnHeaderTitle': {
                            color: '#86BC25FF',
                        },
                        '.MuiTablePagination-root': {
                            color: '#a6a8ab'
                        }
                    }}
                    disableSelectionOnClick
                    className="data-table"
                    rows={itemList}
                    getRowId={(row) => row.entityId ? row.entityId : row.id}
                    columns={columns}
                    filterMode="server"
                    onFilterModelChange={onFilterModelChange}
                    loading={isLoading}
                    columnVisibilityModel={visibleColumns}
                    onColumnVisibilityModelChange={onVisibilityModelChange}
                    rowCount={rowCount}
                    pageSizeOptions={[5, 10, 25]}
                    paginationModel={paginationModel}
                    paginationMode="server"
                    onPaginationModelChange={onPaginationModelChange}
                    slots={{
                        toolbar: CustomToolbar,
                    }}
                />

            </div>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
    }
}

export function CustomToolbar() {
    return (
        <GridToolbarContainer className="data-toolbar">
            <GridToolbarColumnsButton/>
            <GridToolbarFilterButton/>
        </GridToolbarContainer>
    );
}
export default connect(mapStateToProps, {showToastForBackend, showToastForFrontend})(ItemDataDetail);